import {
  Typography as Root,
  type TypographyLegacyVariants,
  type TypographyProps,
  type TokenColor,
  type TypographyVariants
} from './Typography';
import { Body, Display, Title, Heading, Label } from './TypographyVariants';

export const Typography = Object.assign(Root, {
  Body,
  Display,
  Title,
  Heading,
  Label
});

export { type TypographyLegacyVariants, type TypographyProps, type TokenColor, type TypographyVariants };
